export const REGION = 'us-east-1';
export const USER_POOL_ID = 'us-east-1_LsmzM8hel';
export const APP_CLIENT_ID = '5jo2bc5stpbnr5sig168khse5h';
export const IDENTITY_POOL_ID = 'us-east-1:328eaf52-e7b2-4b81-9063-5229730e4ad9';
export const COGNITO_DOMAIN = 'ee-portal-auth-beta.auth.us-east-1.amazoncognito.com';
export const IS_LOCAL_DEV = 'false';
export const STAGE = 'beta';
export const APPEAL_ENABLED = 'true';